import {
    SET_BATCH_LIST_ITEM,
    TOGGLE_BATCH_LIST,
    TOGGLE_BATCH_LIST_ACTIVE
} from '../types'
import _cloneDeep from 'lodash/cloneDeep'
import {storage} from "../../constants/defaultValues"

const lists = localStorage.getItem(storage.batchSelect) ? JSON.parse(localStorage.getItem(storage.batchSelect)) : {}
const INIT_STATE_BATCH_SELECT = {
    lists: lists,
    active: {}
}

export default (state = INIT_STATE_BATCH_SELECT, action = {}) => {
    const newState = _cloneDeep(state)
    const identifier = action.identifier

    switch(action.type) {
        case TOGGLE_BATCH_LIST:
            if(typeof newState.lists[identifier] == "undefined"){
                newState.lists[identifier] = {
                    open: false,
                    ids: []
                }
            }
            newState.lists[identifier].open = !newState.lists[identifier].open

            localStorage.setItem(storage.batchSelect, JSON.stringify(newState.lists))
            return newState
        case SET_BATCH_LIST_ITEM:
            if(identifier && typeof newState.lists[identifier] == "undefined"){
                newState.lists[identifier] = {
                    open: true,
                    ids: [action.id]
                }
            }else{
                if(action.id){
                    const index = newState.lists[identifier].ids.findIndex(i => i == action.id)
                    if(index > -1){
                        newState.lists[identifier].ids.splice(index, 1)
                    }else{
                        newState.lists[identifier].ids.push(action.id)
                    }
                }else{
                    newState.lists[identifier].ids = []
                    newState.lists[identifier].open = false
                }
            }

            localStorage.setItem(storage.batchSelect, JSON.stringify(newState.lists))
            return newState
        case TOGGLE_BATCH_LIST_ACTIVE:
            newState.active[identifier] = action.payload
            return newState
        default:
            return state
    }
}